import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  input: {
    color: 'white',
    fontSize: '14px',
    '&$focused': {
      color: 'white'
    },
    '&:-webkit-autofill': {
      '-webkit-text-fill-color': 'white',
      '-webkit-box-shadow': 'inset 0 0 0 1000px #00c3d7',
      backgroundClip: 'content-box' // https://stackoverflow.com/a/55080978
    }
  },
  underline: {
    color: 'white',
    '&:before': {
      borderColor: 'white'
    },
    '&:hover:not($disabled):before': {
      borderColor: 'white'
    },
    '&:after': {
      borderColor: 'white'
    }
  },
  focused: {},
  disabled: {}
});

export default function LoginInput({ label, onChange, value }) {
  const classes = useStyles();

  return (
    <TextField
      className={classes.root}
      id="login"
      name="login"
      label={label}
      onChange={onChange}
      InputLabelProps={{
        classes: {
          root: classes.input,
          focused: classes.focused
        }
      }}
      InputProps={{
        classes: {
          root: classes.input,
          disabled: classes.disabled,
          underline: classes.underline,
          input: classes.input
        }
      }}
      value={value}
    />
  );
}
